<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading"
           :width="700"
           @on-cancel="cancel"
    >
      <h3 slot="header" class="modal-header">新增店面评级</h3>
      <section style="padding-bottom: 60px">
        <Form :label-width=80 class="mb16" :model="project" :rules="rule" ref="formpro">

          <FormItem class="notip " label="项目名称" style="align-items: center" prop="projectFid">
            <Select size="small" class="formwidth " v-model="project.projectFid" @on-change="getProjectName">
              <!--              <Option value="">请选择</Option>-->
              <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyA'+index">{{item.text}}
              </Option>
            </Select>
            <Button style="margin-left: 20px" type="primary" size="small" @click.stop="add">添加</Button>
          </FormItem>
        </Form>

        <div class="notip">
          <Form :label-width=80 v-for="(item,index) in list" style="width: 100%;"
                inline :key="'keyV'+index"
                :rules="ruleRange"
                :ref="'form'+index"
                :model="item"
          >
            <FormItem label="评级类型" class="notip" prop="typeCode">
              <Select size="small" class="formwidth" v-model="item.typeCode">
<!--                <Option value="">请选择</Option>-->
                <Option v-for="(item,index) in typeList" :value="item.typeCode"
                        :key="'keyB'+index">{{item.typeName}}
                </Option>
              </Select>
            </FormItem>

            <FormItem label="得分" class="notip" prop="score" :label-width=60>
              <InputNumber :min="0" :max="100" v-model="item.score" size="small" class="inputwidth"></InputNumber>
            </FormItem>
            <FormItem label="占比" class="notip" prop="ratio" :label-width=60>
              <InputNumber v-model="item.ratio" size="small"
                           :min="0"
                           :max="100"
              >
              </InputNumber> %
              <Button size="small" style="margin-left: 30px" @click.stop="deleteItem(index)" v-if="index!==0">删除</Button>
            </FormItem>

          </Form>

          <Form :label-width=80 class="mt12" :rules="rule2" ref="formpdate" :model="month">
            <FormItem class="notip " prop="belongMonth" label="归属月份" style="align-items: center">
              <DatePicker type="month"
                          v-model="month.belongMonth"
                          format="yyyy-MM"
                          class="formwidth"
                          size="small"
                          style="display: block"></DatePicker>

            </FormItem>
          </Form>
        </div>
      </section>
    </Modal>
  </div>


</template>
<script>
  import {deepClone} from "../../../../utils/format";
  import {addStoreFrontGrade} from "../../../../api/grade";
import {formatDateTime} from "../../../../utils/format";

  export default {
    name: "",
    props: {
      n: {
        type: Number,
        default: 0
      },
      projectList: {
        type: Array,
        defalut: () => {
          return []
        }
      },
      typeList: {
        type: Array,
        defalut: () => {
          return []
        }

      }
    },
    computed: {
      typeListMap(){
        let ret={}
        this.typeList.forEach(ele=>{
          ret[ele.typeCode+'']=ele.typeName
        })
        return ret
      }
    },
    watch: {
      n() {
        this.project = {
          projectFid: ''
        }
        this.month = {
          belongMonth: ''
        }
        for (let i in this.$refs) {
          if (i === 'formpro' || i === 'formpdate') {
            this.$refs[i].resetFields()
          } else {
            this.$refs[i].forEach(item => {
              item.resetFields()
            })
          }
        }
        this.list = [
          {
            "ratio": null,
            "score": null,
            "typeCode": null,
            "typeName": null
          }
        ]
        this.isShow = true
      }
    },
    data() {
      return {
        loading: true,
        isShow: false,
        singleRule: {},
        project: {
          projectFid: '',
          projectName:''
        },
        month: {
          belongMonth: ''
        },
        list: [
          {
            "ratio": null,
            "score": null,
            "typeCode": null,
            "typeName": null
          }
        ],
        rule: {
          projectFid: [{required: true, message: ' ', trigger: 'change', type: 'string'}],
        },
        rule2: {
          belongMonth: [{required: true, message: ' ', trigger: 'change', type: 'date'}],
        },
        ruleRange: {
          typeCode: [{required: true, message: ' ', trigger: 'change', type: 'string'}],
          score: [{required: true, message: ' ', trigger: 'blur', type: 'number'}],
          ratio: [{required: true, message: ' ', trigger: 'blur', type: 'number'}],

        },
        itemData: {
          "ratio": null,
          "score": null,
          "typeCode": null,
          "typeName": null
        }

      }
    },
    methods: {
      getProjectName(value){
        this.projectList.forEach( ele=>{
          if(ele.value === value){
            this.project.projectName = ele.text
          }
        })
      },
      deleteItem(index) {
        this.list.splice(index, 1)

      },
      saveMeta() {
        this.list.forEach(ele=>{
          ele.typeName=this.typeListMap[ele.typeCode+'']
        })
        let params = {
          projectFid: this.project.projectFid,
          projectName: this.project.projectName,

          storeFrontGradeTypeDtoList: this.list,
          belongMonth: formatDateTime(this.month.belongMonth).slice(0,7)
        }
        addStoreFrontGrade(params).then(res => {
          this.$emit('done')
          this.$Message.success('保存成功')
          this.isShow = false

        }).catch(error => {
          this.changeLoading()
        }).finally(() => {

        })

      },
      add() {
        this.list.push(deepClone(this.itemData))
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        // if (!this.list.length) {
        //   this.$Message.info('请添加评级数据')
        //   this.changeLoading()
        //   return
        // }

        let validate = true

        for (let i in this.$refs) {
          if (i === 'formpro' || i === 'formpdate') {
            this.$refs[i].validate(bool => {
              !bool && (validate = bool)

            })
          } else {
            this.$refs[i].forEach(item => {
              item.validate(bool => {
                !bool && (validate = bool)
              })
            })
          }
        }
        if (!validate) {
          this.changeLoading()
          return
        }

        this.saveMeta()
      },
      cancel() {

      }
    }

  }
</script>

<style scoped>
  .formwidth {
    width: 150px;
    display: inline-block;
  }

  .inputwidth {
    width: 80px;
  }

</style>
